export const TABLE_DISPLAY_LABEL = 'Detaljer';
